import { Component, HostBinding, Input, Signal, signal } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';
import { ICountDashboard } from '../../models/dashboard-card.model';
import { toSignal } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';  
import { MatCard } from '@angular/material/card';
import { MatCardContent } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { Router } from '@angular/router';
@Component({
  selector: 'app-dashboard-card',
  standalone: true,
  imports: [CommonModule,MatCard,MatCardContent, MatIcon],
  templateUrl: './dashboard-card.component.html',
  styleUrl: './dashboard-card.component.css'
})
export class DashboardCardComponent {
  type: string = 'outlined';
  title: string = 'titolo';
  icon?: string;
  color?: string;
  maxHeight?: string;
  data:Signal<ICountDashboard>=signal({
    countControlli: 0,
    countDatiPrelievo: 0,
    countPuntiCampionamento: 0,
    error: null
  });
  constructor( private api: ApiService, private router:Router){
    this.data=toSignal( this.api.get<ICountDashboard>('count')) as Signal<ICountDashboard>;
  }

  ngOnInit(){
  

  }
  get backgroundColor() {
    let backgroundColor = 'surface-container-low';
    if (this.color) {
      backgroundColor = this.color + '-container';
    } else {
      switch (this.type) {
        case 'elevated':
          backgroundColor = 'surface-container-low';
          break;
        case 'filled':
          backgroundColor = 'surface-container-highest';
          break;
        case 'outlined':
          backgroundColor = 'surface';
          break;
      }
    }
    return backgroundColor;
  }

  get borderClass() {
    let borderColor = '';
    if (this.color) {
      borderColor = 'outline-' + this.color;
    } else {
      switch (this.type) {
        case 'elevated':
          borderColor = '';
          break;
        case 'filled':
          borderColor = '';
          break;
        case 'outlined':
          borderColor = 'outline-variant';
          break;
      }
    }
    return `border-round-lg ${this.type === 'outlined' ? 'border-1' : ''} ${borderColor}`;
  }

  get typeClass() {
    let typeClass = '';
    switch (this.type) {
      case 'elevated':
        typeClass = 'elevated-2';
        break;
      case 'filled':
        typeClass = '';
        break;
      case 'outlined':
        typeClass = '';
        break;
    }
    return typeClass;
  }

  @HostBinding('class') get hostClass() {
    return ` flex justify-content-center align-content-center align-items-center ${this.backgroundColor} ${this.borderClass} ${this.typeClass} p-2`;
  }

  goDetail(detailUrl:string){
    this.router.navigate([detailUrl])
  }
}
